module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    staticClass: "elevation-2 content"
  }, [(_vm.viewedDevice.id !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath
    }
  }, [_c('v-btn', {
    staticClass: "back-button",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v(" " + _vm._s(_vm.lng.back) + "\n\t\t\t\t\t")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.viewedDevice.title))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Ventilation unit for fully automatic, demand-oriented, decentralized ventilation systems. Through optimized control via the HAQCS monitor, it saves heating energy more effectively than when controlled by humans.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Ventilation unit that is factory-equipped with HAQCS compatibility and can also be manually controlled via a smartphone app.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-HAQCS-Edition',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('p', [_vm._v(" Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v(" Upgrade for Marley MEnV 180 to HAQCS ")]), _vm._v(" "), _c('p', [_vm._v(" Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v(" Upgrade for Prana 150/200 ")]), _vm._v(" "), _c('p', [_vm._v(" Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v(" Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/haqcs.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Measurement of air quality and indoor climate ")]), _vm._v(" "), _c('li', [_vm._v(" Display of current values ​​as numbers and graphically ")]), _vm._v(" "), _c('li', [_vm._v(" Display the trends of the last 3 or 12 hours ")]), _vm._v(" "), _c('li', [_vm._v(" Air quality can be read even when the screen is switched off ")]), _vm._v(" "), _c('li', [_vm._v(" Alarms at threshold values ​​of CO"), _c('sub', [_vm._v("2")]), _vm._v(" optically and acoustically ")]), _vm._v(" "), _c('li', [_vm._v(" Control of compatible ventilation units (up to 16 at a time), 3 automatic modes, night mode, intensive mode, manual control, automatic dehumidification mode, summer mode ")]), _vm._v(" "), _c('li', [_vm._v(" Control of compatible humidifiers ")]), _vm._v(" "), _c('li', [_vm._v(" Retains settings after a power failure ")]), _vm._v(" "), _c('li', [_vm._v(" Does not require a router as it works without being connected to the Internet ")]), _vm._v(" "), _c('li', [_vm._v(" Can hang on the wall or stand on horizontal surfaces ")]), _vm._v(" "), _c('li', [_vm._v(" Wireless communication with devices with WiFi technology (no IP protocol) ")]), _vm._v(" "), _c('li', [_vm._v(" Range corresponds to WiFi ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Internal sensors ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Carbon dioxide CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v(" TVOC ")]), _vm._v(" "), _c('li', [_vm._v(" Temperature ")]), _vm._v(" "), _c('li', [_vm._v(" Relative humidity ")]), _vm._v(" "), _c('li', [_vm._v(" Light sensor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Screen ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 3.5 inch color screen 480 x 320 pixels "), _c('br'), _vm._v(" touch sensitive ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" LED display ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 8 RGB LEDs ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power supply ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 5 V USB power supply, micro-USB connections from below and from the side ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Colors ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Bordeaux, dark green, gray ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v(" USB power supply ")]), _vm._v(" "), _c('li', [_vm._v("Micro-USB cable")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Ambientika+HAQCS.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Upgrade of an Ambientika brand model to HAQCS compatibility. Together with the HAQCS monitor, it forms a fully automated, demand-oriented ventilation system that optimizes ventilation and thus saves heating energy, something humans cannot do.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This makes it our top model.")]), _vm._v(" "), _c('h2', [_vm._v("Features:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Communicates with HAQCS monitor and is regulated by it")]), _vm._v(" "), _c('li', [_vm._v("Continuous control of ventilation intensity")]), _vm._v(" "), _c('li', [_vm._v("Automatically closes the air duct when not ventilating")]), _vm._v(" "), _c('li', [_vm._v("Displays current ventilation intensity with a colored LED")]), _vm._v(" "), _c('li', [_vm._v("Requires a HAQCS monitor for control")]), _vm._v(" "), _c('li', [_vm._v("Equipped with G3 filter")]), _vm._v(" "), _c('li', [_vm._v("All service activities can be performed from the inside")]), _vm._v(" "), _c('li', [_vm._v("Automatically adjusts the brightness of the display")])])]), _vm._v(" "), _c('h2', [_vm._v("Technical specifikations:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Airflow:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Continuously up to 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Power consumption:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Below 7 Watts")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Noise level:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) at maximum speed")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Heat recovery:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Up to 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/HW_app_moni.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Ventilation device from the Alnor brand, factory-equipped with HAQCS compatibility, thus ventilating fully automatically based on demand and optimally saving heating energy. For budget solutions, it can also be manually controlled via a smartphone app.")]), _vm._v(" "), _c('h2', [_vm._v("Advantages:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS compatibility - retrofittable automatic demand-driven ventilation control based on measurements of indoor air quality in conjunction with the HAQCS monitor.")]), _vm._v(" "), _c('li', [_vm._v("Easy installation in exterior walls with minimal wiring.")]), _vm._v(" "), _c('li', [_vm._v("High delivery capacity: 20, 40, and 60 m³/h of air.")]), _vm._v(" "), _c('li', [_vm._v("Built-in humidity sensor for automatic dehumidification when needed.")]), _vm._v(" "), _c('li', [_vm._v("Quiet operation.")]), _vm._v(" "), _c('li', [_vm._v("Free app for control.")]), _vm._v(" "), _c('li', [_vm._v("Easy to clean.")])])]), _vm._v(" "), _c('h2', [_vm._v("Control:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Controlled by the HAQCS monitor based on data from its sensors. Always fresh air according to demand and energy savings. Automatic. Alternatively, manual control with the free WallAIR app.")]), _vm._v(" "), _c('h2', [_vm._v("Service:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("All service and maintenance tasks can be conveniently and affordably performed from the interior. No need for external scaffolding.")]), _vm._v(" "), _c('h2', [_vm._v("Technical Specifications:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("3 performance levels:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Exterior wall thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Power consumption:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1.4 – 3.8 watts")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Sound pressure level (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Sound insulation from the outside:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (equivalent to window class 3 according to VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Heat recovery:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Average 74.3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/marley-MEnV-HAQCS-edition.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with and is regulated by the HAQCS monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Shows current ventilation intensity with a colored LED ")]), _vm._v(" "), _c('li', [_vm._v(" Requires a HAQCS monitor for control ")]), _vm._v(" "), _c('li', [_vm._v(" Has G3 and G2 filters, optionally even F7 filters ")]), _vm._v(" "), _c('li', [_vm._v(" All service activities can be carried out from the inside ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Air flow ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 16 - 25 or 37 m³ / h depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power consumption ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 3.5 - 5.0 - 7.5 watts depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Volume ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 22 - 29 - 35 dB(A) depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Heat recovery ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Max 85%, average 79.1% ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('li', [_vm._v(" Filter set for 2 years ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-marley-MEnV180.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS-Monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the fan and the indicator LED ")]), _vm._v(" "), _c('li', [_vm._v(" Monitors the operating time and reminds you to change the filter ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power consumption ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("0,30  - 0,35 W during standby")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Controls for 2 devices ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-prana150-200.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS monitor or remote control ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the fans ")]), _vm._v(" "), _c('li', [_vm._v(" Allows all automatic modes, manual control, night mode, intensive mode and summer mode ")]), _vm._v(" "), _c('li', [_vm._v(" Displays the ventilation intensity in 1% increments ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Control board for 1 device ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Unibox.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox.")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS-Monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the connected fans ")]), _vm._v(" "), _c('li', [_vm._v(" Displays current ventilation intensity in 1% increments ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Control power ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max:  150 W")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Input voltage ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 230 V, 110 V ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Frequency ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 50 Hz, 60 Hz ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" HAQCS Unibox with mounting material ")])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Lüftungsgerät für vollautomatische, bedarfsorientierte, dezentrale Lüftungssysteme. Durch optimierte Steuerung per HAQCS-Monitor spart Heizungswärme effektiver als bei Steuerung durch Menschen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Lüftungsgerät das vom Werk aus HAQCS-kompatibel ist und auch manuell, per Smartphone-App gesteuert werden kann. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-HAQCS-Edition',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('p', [_vm._v("Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Upgrade für Marley MEnV 180 auf HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Upgrade für Prana 150 / 200")]), _vm._v(" "), _c('p', [_vm._v("Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v("Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/haqcs.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung. ")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Messung der Luftqualität und des Raumklimas")]), _vm._v(" "), _c('li', [_vm._v("Anzeige aktueller Werte als Zahlen und grafisch")]), _vm._v(" "), _c('li', [_vm._v("Anzeige der Trends der letzten 3 oder 12 Stunden")]), _vm._v(" "), _c('li', [_vm._v("Luftqualität auch beim abgeschalteten Bildschirm ablesbar")]), _vm._v(" "), _c('li', [_vm._v("Alarme bei Schwellenwerten von CO"), _c('sub', [_vm._v("2")]), _vm._v(" optisch und akustisch")]), _vm._v(" "), _c('li', [_vm._v("Regelung von kompatiblen Lüftungsgeräten (bis zu 16 gleichzeitig), 3 automatische Modi, Nachtmodus, Intensivmodus, manuelle Steuerung, Automatischer Entfeuchtungsmodus, Sommermodus")]), _vm._v(" "), _c('li', [_vm._v("Regelung von kompatiblen Luftbefeuchtern ")]), _vm._v(" "), _c('li', [_vm._v("Behält Einstellungen nach einem Stromausfall")]), _vm._v(" "), _c('li', [_vm._v("Benötigt keinen Router, keine Verbindung mit dem Internet")]), _vm._v(" "), _c('li', [_vm._v("Kann an der Wand hängen, oder auf waagerechten Flächen stehen")]), _vm._v(" "), _c('li', [_vm._v("Drahtlose Kommunikation mit den Geräten mit WiFi-Technik (kein IP-Protokoll)")]), _vm._v(" "), _c('li', [_vm._v("Reichweite entspricht WiFi")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Interne Sensoren")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kohlendioxid CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v("TVOC")]), _vm._v(" "), _c('li', [_vm._v("Temperatur")]), _vm._v(" "), _c('li', [_vm._v("Relative Feuchte")]), _vm._v(" "), _c('li', [_vm._v("Lichtsensor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Bildschirm")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5 Zoll Farbbildschirm 480 x 320 Pixel"), _c('br'), _vm._v("Berührungssensitiv")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("LED-Anzeige")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("8 RGB Leuchtdioden")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromversorgung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("5 V USB-Netzteil, Anschlüsse micro-USB von unten und seitlich")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Farben")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bordeaux, dunkel grün, grau")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("USB-Netzteil")]), _vm._v(" "), _c('li', [_vm._v("Micro-USB Kabel")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Ambientika+HAQCS.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Upgrade eines Models der Marke Ambientika zu HAQCS-Kompatibilität. Zusammen mit dem HAQCS-Monitor bildet vollautomatisches, bedarfsorientiertes  Lüftungssystem das optimiert die Lüftung und spart dadurch Heizungsenergie, was Menschen nicht können. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Dadurch ist das unser Top-Model.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt")]), _vm._v(" "), _c('li', [_vm._v("Stufenlose Regelung der Lüftungsintensität")]), _vm._v(" "), _c('li', [_vm._v("Verschließt automatisch den Luftkanal wenn nicht gelüftet wird")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an")]), _vm._v(" "), _c('li', [_vm._v("Benötigt einen HAQCS-Monitor zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Verfügt über G3 – Filter")]), _vm._v(" "), _c('li', [_vm._v("Alle Service-Tätigkeiten durchführbar von innen")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Luftdurchsatz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Stufenlos bis 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Unter 7 Watt")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Lautstärke")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) bei max. Geschwindigkeit")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("bis 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/HW_app_moni.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Lüftungsgerät der Marke Alnor, das vom Werk aus HAQCS-Kompatibel ist und daher vollautomatisch bedarfsgeführt lüftet und spart optimal die Heizwärme. Für Budgetlösungen kann es auch manuell per Smartphone-App gesteuert werden.")]), _vm._v(" "), _c('h2', [_vm._v("Vorteile:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_c('b', [_vm._v("HAQCS-Kompatibilität")]), _vm._v(" - nachrüstbare automatische bedarfsgerechte Regelung der Lüftung anhand von Messungen der Luftqualität im Raum in Verbindung mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Einfache Montage in den Außenwänden mit minimaler Verkabelung")]), _vm._v(" "), _c('li', [_vm._v("Große Förderleistung 20, 40 und 60 m³/h Luft")]), _vm._v(" "), _c('li', [_vm._v("eingebauter Feuchtesensor zur automatischen Entfeuchtung bei Bedarf.")]), _vm._v(" "), _c('li', [_vm._v("Leise")]), _vm._v(" "), _c('li', [_vm._v("kostenlose App zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Leicht zu reinigen")])])]), _vm._v(" "), _c('h2', [_vm._v("Steuerung")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Steuerung durch den HAQCS-Monitor anhand der Daten aus seinen Sensoren. Immer frische Luft entsprechend dem Bedarf und Energieeinsparung. Automatisch.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Alternativ manuelle Steuerung mit der kostenlosen App WallAIR.")]), _vm._v(" "), _c('h2', [_vm._v("Service von Innen")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Sämtliche Service- und Wartungsarbeiten lassen sich bequem und günstig vom Innenraum her durchführen. Es besteht keine Notwendigkeit für Außengerüste.")]), _vm._v(" "), _c('h2', [_vm._v("Technical Specifications:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("3 Leistungsstufen")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Außenwandstärken:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Leistungsaufnahme:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1,4 –3,8 Watt")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Schalldruckpegel (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Schalldämmung von außen:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (entspricht Fensterklasse 3 nach VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Mittel 74,3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/marley-MEnV-HAQCS-edition.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität. ")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an")]), _vm._v(" "), _c('li', [_vm._v("Benötigt einen HAQCS-Monitor zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Verfügt über G3 und G2 – Filter, optional sogar F7 – Filter")]), _vm._v(" "), _c('li', [_vm._v("Alle Service-Tätigkeiten durchführbar von innen")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Luftdurchsatz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("16  -  25  oder 37 m³/h je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5  -   5,0  -  7,5 Watt je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Lautstärke")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("22  -  29  -  35  dB(A) je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max 85%,  Durchschnittlich 79,1%")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('li', [_vm._v("Filtersatz für 2 Jahre")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-marley-MEnV180.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Steuert den Lüfter und die Anzeigen-LED")]), _vm._v(" "), _c('li', [_vm._v("Überwacht die Betriebszeit und erinnert an Filterwechsel")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("0,30  - 0,35 W in Stand-by")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Steuerungen für 2 Geräte")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-prana150-200.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor oder Fernbedienung")]), _vm._v(" "), _c('li', [_vm._v("Steuert die Lüfter")]), _vm._v(" "), _c('li', [_vm._v("Erlaubt alle Automatikmodi, manuelle Steuerung, Nachtmodus, Intensivmodus und Sommermodus")]), _vm._v(" "), _c('li', [_vm._v("Zeigt die Lüftungsintensität in 1%-Schritten an")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Steuerung für 1 Gerät")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Unibox.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Steuert die angeschlossenen Ventilatoren")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität in 1%-Schritten an")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Regelleistung ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max:  150 W")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Eingangspannung ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("230 V, 110 V")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Frequenz ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("50 Hz, 60 Hz")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Unibox mit Montagematerial")])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Monitor HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Urządzenie wentylacyjne do w pełni automatycznych, zdecentralizowanych systemów wentylacyjnych. Dzięki sterowaniu według aktualnego zapotrzebowania optymalizowanej za pomocą monitora HAQCS, oszczędza energię grzewczą bardziej efektywnie niż w przypadku sterowania przez ludzi.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Urządzenie wentylacyjne, które jest fabrycznie kompatybilne z systemem HAQCS i może być również sterowane ręcznie za pomocą aplikacji na smartfona.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-Edycja-HAQCS',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV Edycja HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ulepszenie-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ulepszenie dla Marley MEnV 180 na HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ulepszenie-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ulepszenie dla Prana 150 / 200")]), _vm._v(" "), _c('p', [_vm._v("Centrala sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez HAQCS-Monitor.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v("Regulator wydajności dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/haqcs.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Pomiar jakości powietrza i klimatu w pomieszczeniu")]), _vm._v(" "), _c('li', [_vm._v("Wyświetlanie bieżących wartości jako liczb i graficznie")]), _vm._v(" "), _c('li', [_vm._v("Wyświetla trendy z ostatnich 3 lub 12 godzin")]), _vm._v(" "), _c('li', [_vm._v("Jakość powietrza można również odczytać, gdy ekran jest wyłączony")]), _vm._v(" "), _c('li', [_vm._v("Alarmy przy wartościach progowych CO"), _c('sub', [_vm._v("2")]), _vm._v(" optycznie i akustycznie")]), _vm._v(" "), _c('li', [_vm._v("Sterowanie kompatybilnymi urządzeniami wentylacyjnymi (do 16 jednocześnie), 3 tryby automatyczne, tryb nocny, tryb intensywny, sterowanie ręczne, tryb automatycznego osuszania, tryb letni")]), _vm._v(" "), _c('li', [_vm._v("Kontrola kompatybilnych nawilżaczy")]), _vm._v(" "), _c('li', [_vm._v("Zachowuje ustawienia po awarii zasilania")]), _vm._v(" "), _c('li', [_vm._v("Nie wymaga routera, nie ma połączenia z Internetem")]), _vm._v(" "), _c('li', [_vm._v("Może wisieć na ścianie lub stać na poziomych powierzchniach")]), _vm._v(" "), _c('li', [_vm._v("Bezprzewodowa komunikacja z urządzeniami z technologią WiFi (bez protokołu IP)")]), _vm._v(" "), _c('li', [_vm._v("Zasięg odpowiada Wi-Fi")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Czujniki wewnętrzne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Dwutlenek węgla CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v("TVOC")]), _vm._v(" "), _c('li', [_vm._v("Temperatura")]), _vm._v(" "), _c('li', [_vm._v("Wilgotność względna")]), _vm._v(" "), _c('li', [_vm._v("Czujnik światła")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Screen")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Kolorowy ekran 3,5 cala 480 x 320 pikseli "), _c('br'), _vm._v(" wrażliwy na dotyk")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wyświetlacz LED")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("8 diody LED RGB")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zasilacz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Zasilacz USB 5 V, złącza micro-USB od dołu i z boku")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Kolory")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bordeaux, ciemnozielony, szary")])])]), _vm._v(" "), _c('h2', [_vm._v("Zakres dostawy:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Zasilacz USB")]), _vm._v(" "), _c('li', [_vm._v("Kabel Micro-USB")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Ambientika+HAQCS.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Aktualizacja modelu marki Ambientika do zgodności z HAQCS. Razem z monitorem HAQCS tworzy w pełni zautomatyzowany, dostosowany do zapotrzebowania system wentylacji, który optymalizuje wentylację, co pozwala oszczędzać energię ogrzewania, czego ludzie sami nie są w stanie zrobić.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To sprawia, że jest to nasz najlepszy model.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS i jest przez niego regulowany")]), _vm._v(" "), _c('li', [_vm._v("Bezstopniowa regulacja intensywności wentylacji")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie zamyka kanał powietrzny, gdy nie jest używany")]), _vm._v(" "), _c('li', [_vm._v("Wyświetla aktualną intensywność wentylacji za pomocą kolorowej diody LED")]), _vm._v(" "), _c('li', [_vm._v("Wymaga monitora HAQCS do sterowania")]), _vm._v(" "), _c('li', [_vm._v("Wyposażony w filtr G3")]), _vm._v(" "), _c('li', [_vm._v("Wszystkie czynności serwisowe możliwe do wykonania od wewnątrz")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie reguluje jasność wyświetlacza")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Przepływ powietrza:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("bezstopniowy do 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zużycie energii:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("poniżej 7 watów")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Poziom hałasu:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) przy maksymalnej prędkości")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("do 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/HW_app_moni.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Urządzenie wentylacyjne marki Alnor, fabrycznie kompatybilne z HAQCS, dzięki czemu wentyluje w pełni automatycznie, zgodnie z zapotrzebowaniem i optymalnie oszczędza energię grzewczą. Dla rozwiązań budżetowych może być także sterowane ręcznie za pomocą aplikacji na smartfona.")]), _vm._v(" "), _c('h2', [_vm._v("Zalety:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Zgodność z HAQCS - automatyczna regulacja wentylacji na podstawie pomiarów jakości powietrza w pomieszczeniu, we współpracy z monitorem HAQCS.")]), _vm._v(" "), _c('li', [_vm._v("Łatwy montaż w ścianach zewnętrznych przy minimalnym okablowaniu.")]), _vm._v(" "), _c('li', [_vm._v("Wysoka wydajność: 20, 40 i 60 m³/h powietrza.")]), _vm._v(" "), _c('li', [_vm._v("Wbudowany czujnik wilgotności do automatycznego odwilgocania w razie potrzeby.")]), _vm._v(" "), _c('li', [_vm._v("Ciche działanie.")]), _vm._v(" "), _c('li', [_vm._v("Darmowa aplikacja do sterowania.")]), _vm._v(" "), _c('li', [_vm._v("Łatwe do czyszczenia.")])])]), _vm._v(" "), _c('h2', [_vm._v("Sterowanie")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Sterowane przez monitor HAQCS na podstawie danych z jego czujników. Zawsze świeże powietrze zgodnie z zapotrzebowaniem i oszczędność energii. Automatycznie.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Alternatywnie, ręczne sterowanie za pomocą bezpłatnej aplikacji WallAIR..")]), _vm._v(" "), _c('h2', [_vm._v("Obsługa od wewnątrz")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Wszystkie prace serwisowe i konserwacyjne można łatwo i ekonomicznie wykonywać od wewnątrz. Nie ma potrzeby stosowania rusztowań zewnętrznych.")]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Dane techniczne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Grubość ściany zewnętrznej:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zużycie energii:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1,4 – 3,8 watów")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Poziom ciśnienia akustycznego (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Izolacja dźwiękowa od zewnątrz:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (odpowiada klasie okna 3 według VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Średnio 74,3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/marley-MEnV-HAQCS-edition.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS. ")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS i jest regulowany przez ten monitor")]), _vm._v(" "), _c('li', [_vm._v("Pokazuje aktualną intensywność wentylacji za pomocą kolorowej diody LED")]), _vm._v(" "), _c('li', [_vm._v("Wymaga monitora HAQCS do kontroli")]), _vm._v(" "), _c('li', [_vm._v("Posiada filtry G3 i G2, opcjonalnie nawet filtry F7")]), _vm._v(" "), _c('li', [_vm._v("Wszystkie czynności serwisowe można wykonywać od wewnątrz")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie kontroluje jasność wyświetlacza")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Przepływ powietrza")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("16–25 lub 37 m³ / h w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Pobór mocy")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5 - 5,0 - 7,5 watów w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Głośność")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("22 - 29 - 35 dB(A) w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Maks. 85%, średnio 79,1%")])])]), _vm._v(" "), _c('h2', [_vm._v("Zakres dostawy:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV Edycja HAQCS")]), _vm._v(" "), _c('li', [_vm._v("Zestaw filtrów na 2 lata")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-marley-MEnV180.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS")]), _vm._v(" "), _c('li', [_vm._v("Kontroluje diodę LED wentylatora i wskaźnika")]), _vm._v(" "), _c('li', [_vm._v("Monitoruje czas pracy i przypomina, aby zmienić filtr")])])]), _vm._v(" "), _c('h2', [_vm._v(" Dane techniczne: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Pobór mocy ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 0,30 - 0,35 W w trybie czuwania ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Sterowanie dla 2 urządzeń ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": require("../../static/img/offer/upgrade-prana150-200.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Płyta sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez monitor HAQCS. ")]), _vm._v(" "), _c('h2', [_vm._v(" Funkcje: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Komunikuje się z monitorem HAQCS lub pilotem zdalnego sterowania ")]), _vm._v(" "), _c('li', [_vm._v(" Kontroluje wentylatory ")]), _vm._v(" "), _c('li', [_vm._v(" Umożliwia wszystkie tryby automatyczne, sterowanie ręczne, tryb nocny, tryb intensywny i tryb letni ")]), _vm._v(" "), _c('li', [_vm._v(" Wyświetla intensywność wentylacji w krokach co 1% ")]), _vm._v(" "), _c('li', [_vm._v(" Automatycznie kontroluje jasność wyświetlacza ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Sterowanie dla 1 urządzenia ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": require("../../static/img/offer/Unibox.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Sterownik mocy dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.")]), _vm._v(" "), _c('h2', [_vm._v(" Funkcje: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Komunikuje się z monitorem HAQCS ")]), _vm._v(" "), _c('li', [_vm._v(" Kontroluje podłączone wentylatory ")]), _vm._v(" "), _c('li', [_vm._v(" Wyświetla aktualną intensywność wentylacji w krokach co 1% ")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie kontroluje jasność wyświetlacza ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Dane techniczne: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Moc kontrolna ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Max: 150 W ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Napięcie wejściowe ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 230 V, 110 V ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Częstotliwość ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("50 Hz, 60 Hz")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" HAQCS Unibox z materiałem montażowym ")])])])], 1)], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50vh"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112126b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Angebot.vue
// module id = 157
// module chunks = 1 2